import moment from "moment";
import { each } from "lodash";
import axios from "axios";
import s3BucketApiCallWrapper from "./S3BucketApi";
import Toaster from "common/Toaster";

export const INITIAL_DATA_TABLE_LIMIT = 25;

export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const MEDIA_URL = process.env.REACT_APP_MEDIA_URL;

export const getSizeInKb = (value) => {
  let KB = value / 1024;
  return `${Math.floor(KB)}`;
};

export const getFilteredValue = (filter, skipIfFalse) => {
  const copyFilter = { ...filter };
  let newFilter = {};
  each(copyFilter, (val, key) => {
    if (typeof val.value === "boolean" || val.value) {
      newFilter[key] = val.value;
    }
    if (val.type === "date") {
      if (!val.value || !moment(val.value).isValid()) {
        delete newFilter[key];
      } else {
        newFilter[key] = moment(val.value).format("YYYY-MM-DD");
      }
    }
  });
  return newFilter;
};

export const isImage = (url) => {
  const imageType = ["jpg", "jpeg", "png", "svg", "webp", "gif"];

  let arr = url.split(".");
  let urlExtension = arr[arr.length - 1];

  return imageType.includes(urlExtension);
};

export const isVideo = (url) => {
  const videoType = ["mp4", "mov", "wmv", "avi", "mkv", "mpeg-2"];

  let arr = url.split(".");
  let urlExtension = arr[arr.length - 1];

  return videoType.includes(urlExtension);
};

export const getTwoDecimal = (number) => {
  // return Number(number.toString().match(/^\d+(?:\.\d{0,2})?/));
  return Number(number).toFixed(2);
};

export const getAge = (dob) => {
  const today = new Date();

  const age = Math.abs(moment(today).year() - moment(dob).year());
  if (age) {
    return age;
  } else return "-";
};

export const getImageUrl = (path) => {
  if (path.includes("http")) {
    return path;
  } else {
    return process.env.REACT_APP_MEDIA_URL + path;
  }
};

export const genderTypeOptions = [
  { name: "Male", value: "male" },
  { name: "Female", value: "female" },
  { name: "Not-specified", value: "not-specified" },
];
export function b64toBlob(b64Data, contentType, sliceSize) {
  contentType = contentType || "";
  sliceSize = sliceSize || 512;

  var byteCharacters = window.atob(b64Data);
  var byteArrays = [];

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);

    var byteNumbers = new Array(slice.length);
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    var byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  return new File(byteArrays, "pot", { type: contentType });
}

export const calculatePackagePrices = (values, priceType) => {
  const { price, discountAmount, vatPercent } = values;

  let actualPrice;
  let priceAfterDiscount;
  let priceWithTax;

  if (priceType === "inclusive") {
    let temp = (100 + +vatPercent) / 100;
    actualPrice = +(price / temp).toFixed(2);
    priceAfterDiscount = actualPrice - discountAmount;
    priceWithTax = priceAfterDiscount + (priceAfterDiscount * vatPercent) / 100;
  } else {
    actualPrice = +price;
    priceAfterDiscount = price - discountAmount;
    priceWithTax = priceAfterDiscount + (priceAfterDiscount * vatPercent) / 100;
  }

  return {
    actualPrice,
    priceAfterDiscount,
    priceWithTax:
      priceType === "inclusive"
        ? Math.round(priceWithTax)
        : priceWithTax.toFixed(2),
  };
};
//Get Error Message
export function getErrorMessage(data) {
  let returnError = [];
  if (typeof data === "string") return data;
  if (Array.isArray(data)) {
    for (let i = 0; i < data.length; i++) {
      let errorValue = "";
      for (const [key, value] of Object.entries(data[i])) {
        errorValue += value + " ";
      }
      returnError.push(errorValue + "|  ");
      errorValue = "";
    }
    return returnError;
  } else {
    for (const [key, value] of Object.entries(data)) {
      if (Array.isArray(value)) {
        for (let i = 0; i < value.length; i++) {
          const element = value[i];
          return element;
        }
      } else return value;
    }
  }
}
export const getFullDateWithTime = (time) => {
  return moment()
    .set("hour", time.split(":")[0])
    .set("minute", time.split(":")[1])
    .format("h:mm a");
};
export const getIpAddress = async () => {
  await axios.get("https://api.ipify.org?format=json").then((item) => {
    localStorage.setItem("ip", item.data.ip);
  });
};

export const setTextLength = (text, length) => {
  if (text.length < length) return text;
  else return text.slice(0, length).concat("...");
};
export const saveFilterData = (key, data) => {
  sessionStorage.setItem(key, JSON.stringify(data));
};
export const getSaveFilterData = (key) => {
  let filterData = sessionStorage.getItem(key);
  return filterData ? JSON.parse(filterData) : null;
};

export const getDifferenceBetweenTwoDays = (startDate, endDate) => {
  let date1 = new Date(startDate);
  var date2 = new Date(endDate);

  // To calculate the time difference of two dates
  let Difference_In_Time = date2.getTime() - date1.getTime();

  let Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
  return Difference_In_Days;
};

export const getWeekNumber = (date) => {
  // Copy date so don't modify original
  date = new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
  );
  // Set to nearest Thursday: current date + 4 - current day number
  // Sunday is 0, Monday is 1, etc.
  date.setUTCDate(date.getUTCDate() + 4 - (date.getUTCDay() || 7));
  // Get first day of year
  var yearStart = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));
  // Calculate full weeks to nearest Thursday
  var weekNo = Math.ceil(((date - yearStart) / 86400000 + 1) / 7);
  return weekNo;
};

export const getGraphData = (graphData, title) => {
  let labels = [];
  let count = [];

  for (let i = 0; i < graphData.length; i++) {
    labels.push(moment(graphData[i].date).format("DD MMM YYYY"));
    count.push(graphData[i].count || graphData[i].amount);
  }

  const data = {
    labels,
    datasets: [
      {
        label: title,
        data: count,
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
    ],
  };

  return data;
};
export const formatGraphData = (arr, specificKey) => {
  if (arr[0]?.count) {
    return arr;
  } else {
    const secondKey = specificKey
      ? specificKey
      : Object.keys(arr[0]).find((key) => key !== "date");

    return arr.map((item) => {
      return {
        date: item.date,
        count: item[secondKey],
        ...item,
      };
    });
  }
};
export const handleUploadMediaToBucket = async (file, dir) => {
  try {
    const method = {
      apiType: "POST",
      payload: file,
      dir: dir,
    };
    const result = await s3BucketApiCallWrapper(method);
    return result.location;
  } catch (error) {
    console.log(error);
    Toaster({
      type: "error",
      message: "Failed to upload attachment",
    });
    return "";
  }
};
export const handleDeleteAttachmentFromS3 = async (link, dir) => {
  try {
    const method = {
      apiType: "DELETE",
      payload: link,
      dir: dir,
    };

    await s3BucketApiCallWrapper(method);
    return true;
  } catch (error) {
    Toaster({
      type: "error",
      message: "Failed to delete attachment",
    });
  }
};

export const getPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return "";

  if (
    (phoneNumber.length > 9 && phoneNumber.includes("+971")) ||
    phoneNumber.includes("971")
  ) {
    return phoneNumber.includes("+971")
      ? +phoneNumber.replace("+971", "")
      : +phoneNumber.replace("971", "");
  } else {
    return +phoneNumber;
  }
};
